const toConvertArrayIsEdit = (discountCouponSegment) => {
  return discountCouponSegment.map((couponSegment) => couponSegment?.segment)
}

export default toConvertArrayIsEdit
